import { notification } from "antd"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { extractApiErrorMessage } from "../../../helpers/apiErrorMessage"
import useFeatureFlag from "../../../hooks/useFeatureFlag"
import { InvoiceReminderSchedule } from "./invoiceReminderSchedule"
import { getInvoiceReminderSchedule, updateInvoiceReminderSchedule } from "./invoiceReminderScheduleApi"

export const INVOICE_REMINDERS_FEATURE = 'invoice-reminders'

const invoiceReminderScheduleKey = ['invoicing-settings-reminder-schedule']

export const useInvoiceReminderScheduleQuery = () => {
  const isFeatureEnabled = useFeatureFlag(INVOICE_REMINDERS_FEATURE)

  return useQuery(invoiceReminderScheduleKey, {
    queryFn: getInvoiceReminderSchedule,
    enabled: isFeatureEnabled,
    refetchOnWindowFocus: false,
    staleTime: 30 * 1000,
    onError() {
      notification.error({ message: 'There was a problem loading your invoice reminder schedule.' })
    }
  })
}

export const useInvoiceRemindersAvailable = (): boolean => {
  return useInvoiceReminderScheduleQuery().data?.available === true
}

export const useUpdateInvoiceReminderScheduleMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (schedule: InvoiceReminderSchedule) => updateInvoiceReminderSchedule(schedule),
    onSuccess: () => {
      queryClient.invalidateQueries(invoiceReminderScheduleKey)
    },
    onError(error: unknown) {
      notification.error({
        message: 'There was a problem updating your invoice reminder schedule.',
        description: extractApiErrorMessage(error, '') || undefined
      })
    }
  })
}
